import React from "react";
import { useT } from "../i18n/LanguageContext";
import { SectionTag, SectionTitle, SectionSub } from "../components/Section";
import { PDF } from "../i18n/photos";

const TEAM_IMG = PDF.meeting;
const OFFICE_IMG = PDF.buildingExterior;

export default function AboutPage() {
  const { t } = useT();
  return (
    <main className="pt-32 md:pt-40" data-testid="page-about">
      {/* Intro */}
      <section className="border-b border-white/10 py-16 md:py-24">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <SectionTag>{t("about.tag")}</SectionTag>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {t("about.title")}
          </h1>
          <div className="mt-10 grid gap-10 lg:grid-cols-3">
            <p className="text-base leading-relaxed text-brand-textDim">{t("about.p1")}</p>
            <p className="text-base leading-relaxed text-brand-textDim">{t("about.p2")}</p>
            <p className="text-base leading-relaxed text-brand-textDim">{t("about.p3")}</p>
          </div>
        </div>
      </section>

      {/* Mission / Vision */}
      <section className="border-b border-white/10 py-20 md:py-28">
        <div className="mx-auto grid max-w-[1440px] gap-10 px-6 md:grid-cols-2 md:px-12 lg:px-16">
          <div className="border border-white/10 bg-[#0E0E0E] p-8 md:p-10">
            <p className="font-mono-tag">{t("about.mission.label")}</p>
            <p className="mt-6 font-heading text-2xl leading-snug tracking-tight text-white sm:text-3xl">
              {t("about.mission.body")}
            </p>
          </div>
          <div className="border border-white/10 bg-[#0E0E0E] p-8 md:p-10">
            <p className="font-mono-tag">{t("about.vision.label")}</p>
            <p className="mt-6 font-heading text-2xl leading-snug tracking-tight text-white sm:text-3xl">
              {t("about.vision.body")}
            </p>
          </div>
        </div>
      </section>

      {/* Imagery split */}
      <section className="border-b border-white/10">
        <div className="grid md:grid-cols-2">
          <div className="relative h-80 md:h-[520px]">
            <img src={OFFICE_IMG} alt="Office" className="h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/80 to-transparent" />
            <div className="absolute bottom-6 start-6 font-mono-tag text-white/80">
              Headquarters · Kinshasa, DRC
            </div>
          </div>
          <div className="relative h-80 md:h-[520px]">
            <img src={TEAM_IMG} alt="Team" className="h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/80 to-transparent" />
            <div className="absolute bottom-6 start-6 font-mono-tag text-white/80">
              Continental delivery teams
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
